import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { GetPeoplePerson, SecurityRole } from '../../utils/CommonTypes/PeoplePageTypes';
import { ServerResponse } from '../../utils/Server';
import { isAdminUser } from '../../utils/customRole';
import { ICustomRole } from '../Setup/CustomRoles/CustomRoleTypes';



interface ChangeRoleFormProps {
  person: GetPeoplePerson;
  setModalOpen: (open: boolean) => void;
  refreshAll: () => void;
  settings?: any;
  whoAmI?: any;
  allPeople?: GetPeoplePerson[];
}

interface IRole {
  roles:string;
  value:number;
}

const isStaffSelected = (role: any) => {
  return role === SecurityRole.Staff || role === 7 || role === 'Staff' || SecurityRole[role] === 'Staff';
};

const ChangeRoleForm = (props: ChangeRoleFormProps) => {
  const [personRole, setPersonRole] = useState<any>(props.person.MaxRole);
  const [roleOptions, setRoleOptions] = useState<{value: SecurityRole, label: string}[]>([]);
  const [roles, setRoles] = useState<IRole[]>([]);
  const [customRoles, setCustomRoles] = useState<ICustomRole[]>([]);
  const [customRoleId, setCustomRoleId] = useState<string>('');
  const canAssignCustom = isAdminUser(props.whoAmI);


  useEffect(() => {
    store.server.getApi<ServerResponse<IRole[]>>('../Info/Roles')
    .then(x=>{
      if(x.Success){
        setRoles(x.Value);
      }
    });
    handleRoleOptionsGeneration();
    if (canAssignCustom) {
      store.server.getApi<ServerResponse<ICustomRole[]>>('../CustomRole/List').then((x) => {
        if (x.Success) setCustomRoles(x.Value ?? []);
      });
      store.server
        .postApi<ServerResponse<ICustomRole>>('../CustomRole/ForPerson', { personId: props.person.Id })
        .then((x) => {
          if (x.Success && x.Value) setCustomRoleId(x.Value.PublicId || x.Value.Id || '');
        });
    }
  }, []);

  const handleRoleOptionsGeneration = () => {
    let someArr = Object.entries(SecurityRole);
    let options: any[] = [] 
    for (let i = 0;  i < someArr.length; i++) {
      if( typeof someArr[i][1] !== 'string') {
        if ((props.whoAmI?.SecurityLevel ?? -1000)>= someArr[i][1]) {
          options.push({label: someArr[i][0], value: someArr[i][1]})
        }
      } 
    }
    let sorted = [...options].sort((a, b) => a.value - b.value)
    setRoleOptions(sorted)
  }

  const roleChangeSave = () => {
    const currentIsAdmin = props.person.MaxRole === 'Admin' || props.person.MaxRole === 'Yoda';
    const newRoleIsAdmin = typeof personRole === 'number'
      ? personRole >= SecurityRole.Admin
      : (personRole === 'Admin' || personRole === 'Yoda');
    const whoAmISecLevel: number = props.whoAmI?.SecurityLevel ?? SecurityRole.Unknown;

    if (whoAmISecLevel === SecurityRole.Staff && newRoleIsAdmin) {
      toast.error('Staff accounts cannot promote accounts to Admin.');
      return;
    }

    if (currentIsAdmin && !newRoleIsAdmin) {
      const otherAdmins = (props.allPeople ?? []).filter(
        (p) => p.Id !== props.person.Id && (p.MaxRole === 'Admin' || p.MaxRole === 'Yoda')
      );
      if (otherAdmins.length === 0) {
        toast.error('Cannot demote the only Admin account. Promote another user to Admin first.');
        return;
      }
    }

    let submitObj = {
      userId: props.person.Id,
      newRole: personRole
    }
    store.server.postApi<ServerResponse<object>>('../Person/ChangeRole', submitObj)
      .then((res) => {
      if (!res.Success) {
        toast.error(res.Message || 'Could not change role.', { autoClose: false });
        return;
      }

      const finish = () => {
        toast.success('role changed!')
        props.refreshAll();
        props.setModalOpen(false);
      };

      if (!canAssignCustom) {
        finish();
        return;
      }

      store.server
        .postApi<ServerResponse<object>>('../CustomRole/Assign', {
          PersonId: props.person.Id,
          CustomRoleId: isStaffSelected(personRole) && customRoleId ? customRoleId : null,
        })
        .then((assignRes) => {
          if (!assignRes.Success) {
            toast.error(assignRes.Message || 'Role changed, but custom role was not saved.', { autoClose: false });
            return;
          }
          finish();
        });
    })
  }


  const mappedRoleOptions = roles.map( (role, i) => {
    return (<option value={role.value}>{role.roles}</option>)
  })


  return (
    <>
      <div className='form-group'>
        <label className='control-label col-md-4'>Role: </label>
        <div className='col-md-8'>
          <select
            onChange={(e) => setPersonRole(SecurityRole[e.target.value])}
            value={SecurityRole[personRole]}
            className="form-control"
            id="AdminDirectorySecurityDropdown"
          >
            {mappedRoleOptions}
          </select>
        </div>
      </div>
      {canAssignCustom && isStaffSelected(personRole) && (
        <div className='form-group'>
          <label className='control-label col-md-4'>Custom role: </label>
          <div className='col-md-8'>
            <select
              className="form-control"
              value={customRoleId}
              onChange={(e) => setCustomRoleId(e.target.value)}
            >
              <option value="">Full Staff</option>
              {customRoles.map((role) => {
                const id = role.PublicId || role.Id;
                return (
                  <option key={id} value={id}>
                    {role.Name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      )}
      <div className='form-group'>
        <div className='col-md-8 col-md-offset-4'>
          <button
            type='button'
            className='btn btn-primary btn-block'
            onClick={roleChangeSave}
          >
            Change Role
          </button>
        </div>
      </div>
    </>
  )
}


export default ChangeRoleForm